import React from 'react';
import { Modal, Alert } from 'antd';

export interface CycleDetailCloseModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirmClose: () => Promise<void>;
  cycle: any;
  logs: any[];
  isMobile?: boolean;
}

export const CycleDetailCloseModal: React.FC<CycleDetailCloseModalProps> = ({
  visible,
  onClose,
  onConfirmClose,
  cycle,
  logs,
  isMobile = false,
}) => {
  const showFiniteWarning =
    cycle?.cycle_category === 'FINITE_TRANSFORMATION' &&
    !logs.some((l: any) => l.log_type === 'OUTPUT_HARVEST');

  return (
    <Modal
      title="Cerrar Ciclo Productivo"
      open={visible}
      onCancel={onClose}
      maskClosable={false}
      width={isMobile ? '95%' : 520}
      style={isMobile ? { top: 20 } : undefined}
      onOk={onConfirmClose}
    >
      <p>¿Estás seguro que deseas cerrar este ciclo definitivamente?</p>
      {showFiniteWarning && (
        <Alert
          type="warning"
          showIcon
          message="No se ha registrado ninguna producción (cosecha/salida) en este ciclo. Si es una ceba, debes registrar el OUTPUT antes de cerrar, a menos que sea una pérdida total."
        />
      )}
    </Modal>
  );
};
